import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaExternalLinkAlt } from "react-icons/fa";
import { BiLinkExternal } from "react-icons/bi";

import moment from 'moment';


interface Project {
    [key: string]: any;
}

interface Props {
    projects: Project[];
    progress: boolean;
}

const ProjectDataCard: React.FC<Props> = ({ projects, progress }) => {
    const [data, setData] = useState<Project[]>([]);

    useEffect(() => {
        setData(projects);
    }, [projects]);


    if (data.length === 0) {
        return (
            <div className="no-results-table-ph">
                No projects matching with current search or filters criteria
            </div>
        )
    }


    return (

        <div className="card-view-projects-container">
            {data.length > 0 && (
                data.map((project: any, index: number) => {

                    if (!project.sD_NRROk) {
                        return null;
                    }

                    const today = moment();

                    const dateFields = [
                        { title: 'NRR', dateField: 'nrr', key: 'sD_NRROk', baselineKey: 'sD_NRROkB', statusKey: 'sD_NRROkS' },
                        { title: 'CDR', dateField: 'cdr', key: 'sD_CDROk', baselineKey: 'sD_CDROkB', statusKey: 'sD_CDROkS' },
                        { title: 'CDS', dateField: 'cds', key: 'sD_CDSLay', baselineKey: 'sD_CDSLayB', statusKey: 'sD_CDSLayS' },
                        { title: 'LDV', dateField: 'ldv', key: 'sD_LDVOk', baselineKey: 'sD_LDVOkB', statusKey: 'sD_LDVOkS' },
                    ];

                    return (
                        <Card className="card-view-project" key={index}>
                            <Card.Body className="card-view-project-inner">
                                <h6 className="mb-0 me-5">PIN# <b>{project.projectId}</b> {project.sBrandSub}</h6>
                                <a href={project.sprurl} target='_blank' rel="noopener noreferrer">
                                    <small className="text-muted mb-3">{project.projectTitle} <BiLinkExternal /></small>
                                </a>

                                <div className="project-status-container mt-3">
                                    {dateFields.map((field, fieldIndex) => {
                                        const dueDate = moment(project[field.key]);
                                        const baselineDate = moment(project[field.baselineKey]);

                                        const diffInDays = dueDate.diff(today, 'days');
                                        const baselineDiffDays = baselineDate.diff(dueDate, "days")


                                        let statusText = '';
                                        let statusColor = '';

                                        let statusTextB = '';
                                        let statusColorB = '';

                                        if (diffInDays > 0) {
                                            statusText = `+${diffInDays}d`;
                                            statusColor = 'green';
                                        } else if (diffInDays < 0) {
                                            statusText = `${diffInDays}d`;
                                            statusColor = 'red';
                                        } else {
                                            statusText = '';
                                            statusColor = 'black';
                                        }

                                        if (baselineDiffDays > 0) {
                                            statusTextB = `+${baselineDiffDays}d`;
                                            statusColorB = 'green';
                                        } else if (diffInDays < 0) {
                                            statusTextB = `${baselineDiffDays}d`;
                                            statusColorB = 'red';
                                        } else {
                                            statusTextB = '';
                                            statusColorB = 'black';
                                        }

                                        return (
                                            <Card className="project-status my-2" key={fieldIndex}>
                                                <Card.Body>
                                                    <h6 className="mb-1">
                                                        <b>{field.title}</b>
                                                    </h6>
                                                    <div className="my-2">
                                                        <span className="text-muted">Due:</span> {dueDate.format('MMM DD, YYYY')} <b>{project[field.statusKey]}</b>
                                                    </div>
                                                    <div>
                                                        <div className="card-view-date-header">VS TODAY</div>
                                                        <small style={{ color: statusColor, }} >
                                                            {statusText}
                                                        </small>
                                                    </div>
                                                    {project[field.baselineKey] ? (
                                                        <div>
                                                            <div className="card-view-date-header">VS BASELINE</div>
                                                            <small style={{ color: statusColorB, }} >
                                                                <OverlayTrigger overlay={
                                                                    <Tooltip>
                                                                        <small>
                                                                            Baseline: <b>{baselineDate.format("ll")}</b>
                                                                        </small>
                                                                    </Tooltip>
                                                                }>
                                                                    <div>{statusTextB}</div>
                                                                </OverlayTrigger>

                                                            </small>
                                                        </div>
                                                    )
                                                        :
                                                        (
                                                            <> &nbsp;</>
                                                        )
                                                    }
                                                </Card.Body>
                                            </Card>

                                        );
                                    })}
                                </div>
                            </Card.Body>
                        </Card>
                    );
                })
            )}
        </div >


    );
};

export default ProjectDataCard;